import { useState } from "preact/hooks";

interface Props {
  title: string;
  initialText?: string;
  /** Wenn true, muss vor "Hinzufügen" Text eingegeben sein (z. B. Info-Pseudo-Artikel). */
  required?: boolean;
  confirmLabel?: string;
  onConfirm: (text: string) => void;
  onClose: () => void;
}

/**
 * Schlankes Sheet zum Erfassen einer freien Notiz für eine Bonzeile. Wird verwendet:
 *  - für Info-/Notiz-Pseudo-Artikel (Pflicht-Text, geht über die normale Bon-Pipeline an
 *    den im Artikel hinterlegten Drucker — siehe MenuItem.isInfo)
 *  - für das nachträgliche Bearbeiten der Notiz an einer noch nicht gesendeten Zeile.
 */
export function NoteSheet({ title, initialText = "", required = false, confirmLabel = "Hinzufügen", onConfirm, onClose }: Props) {
  const [text, setText] = useState(initialText);
  const trimmed = text.trim();
  const valid = required ? trimmed.length > 0 : true;

  return (
    <div class="modal-backdrop" onClick={onClose}>
      <div class="sheet" onClick={(e) => e.stopPropagation()}>
        <div class="sheet-head">
          <span class="sheet-title">{title}</span>
          <button class="icon-btn dark" onClick={onClose} aria-label="Schließen">✕</button>
        </div>

        <div class="sheet-body">
          <textarea
            class="note-input"
            rows={4}
            autoFocus
            value={text}
            placeholder={required ? "Text für den Drucker…" : "z. B. ohne Zwiebel, gut durch…"}
            onInput={(e) => setText(e.currentTarget.value)}
          />
        </div>

        <div class="sheet-foot">
          <span />
          <button class="send" disabled={!valid} onClick={() => onConfirm(trimmed)}>
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
